import { Contact } from "@/@types";
import { ContactResponse } from "../../contact/models/ContactResponse";

export function mapContact(response: ContactResponse): Contact {
    return {
        aboutUs: response.about_us,
        offer: response.offer,
        phone: response.phone,
        email: response.email,
        facebook: response.facebook,
        linkedin: response.linkedin,
        youtube: response.youtube,
        instagram: response.instagram,
        metaDescription: response.meta_description,
        metaKeywords: response.meta_keywords,
    }
}